import { getLegalUrl } from '@change-corgi/config/help';
import { getPressUrl } from '@change-corgi/config/press';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';
import { useCountryCodes } from './useCountryCodes';

export function useAboutUsLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const locale = useLocale();
	const countryCodes = useCountryCodes();
	const countryCode = useCountryCode();

	return processLinkGroup({
		title: translate('corgi.components.footer.section.about_us'),
		links: [
			{ href: '/about', title: translate('fe.components.footer.about') },
			{
				href: getLegalUrl(locale, countryCodes),
				title: translate('fe.components.footer.legal_disclosure'),
			},
			{ href: '/impact', title: translate('fe.components.footer.impact') },
			{ href: '/about/team', title: translate('fe.components.footer.team') },
			{ href: 'https://careers.change.org', title: translate('fe.components.footer.careers') },
			{ href: getPressUrl({ locale, countryCode }), title: translate('fe.components.footer.press') },
		],
	});
}
